var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notifications.length)?_c('div',{staticClass:"notification__wrapper"},_vm._l((_vm.notifications),function(ref){
var text = ref.text;
var type = ref.type;
var id = ref.id;
return _c('div',{key:id,class:("notification notification--" + type)},[_c('p',{domProps:{"innerHTML":_vm._s(text)}})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }